/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
const mdSize = {height: 11, h: 11, borderRadius: 'base'}

export default {
    baseStyle: {
        field: {
            _focus: {
                borderColor: 'yellow.400',
                boxShadow: 'none !important'
            },
            _focusVisible: {
                border: '1px solid var(--chakra-colors-yellow-400) !important',
                boxShadow: 'none !important'
            }
        }
    },
    sizes: {
        md: {
            field: mdSize
        }
    }
}
